export default __webpack_public_path__ + "static/media/last.b8ccfe81.png";